export default __webpack_public_path__ + "static/media/p19.e44a7bd3.jpg";